import React, { useState, useEffect } from "react";
import Box from "@mui/system/Box";
import {
  Grid,
  MenuItem,
  Select,
  Button,
  Typography,
  Avatar,
} from "@mui/material";
import styles from "../products/checkout/style.module.css";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import { UserCommonStyles } from "../../styles/CommonStyles";
import { useParams, useLocation } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { RoutingLinks } from "../../utils/constants";
import { getBuyerOrdersDetailByOrder_id } from "../../redux/action-creators/orderAction";
import { useDispatch } from "react-redux";
import minImage from "../../images/minImage.png";
import { capitalize } from "../../utils/helper";

const OrdersDetail = () => {
  const commonStyle = UserCommonStyles();
  const id = useParams<{ id: string }>().id;
  const location = useLocation();
  const dispatch = useDispatch();

  const [loader, setLoader] = useState<boolean>(false);
  const [buyerOrderDetails, setBuyerOrderDetails] = useState<any>([]);
  const [buyerAddressDetail, setBuyerAddressDetail] = useState<any>({});

  const getBuyerOrdersDetaial = async () => {
    if (id) {
      setLoader(true);
      const response: any = await dispatch(getBuyerOrdersDetailByOrder_id(id));
      if (response && response.isFound) {
        setBuyerOrderDetails(response?.data?.data);
        setBuyerAddressDetail(response?.BuyerData);
        console.log(response)
      }
      setLoader(false);
    }
  };

  useEffect(() => {
    if (location.pathname === RoutingLinks.buyerOrdersDetail + id) {
      getBuyerOrdersDetaial();
    } else {
      getBuyerOrdersDetaial();
    }
  }, []);
  return (
    <Box>
      <Grid container>
        <Grid item md={3}>
          <LeftSidebar />
        </Grid>
        <Grid item md={9}>
          {buyerOrderDetails.length > 0 ? (
            <Box className={`${commonStyle.mb20} ${commonStyle.p20}`}>
              <Typography
                mt={2}
                variant="h6"
                className={`${commonStyle.grey} ${commonStyle.mb15} ${commonStyle.fontWeight600}`}
              >
                {`Order Number #${buyerOrderDetails[0]?.order_number}`}
              </Typography>

              {/* Orders List //////////// */}
              <Box className={`${commonStyle.p20} `}>
                <Box>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead style={{ backgroundColor: "#01B4BC" }}>
                        <TableRow>
                          <TableCell
                            align="left"
                            className={commonStyle.tableColumntext}
                          >
                            Items Summary
                          </TableCell>
                          <TableCell
                            align="center"
                            className={commonStyle.tableColumntext}
                          >
                            Quantity
                          </TableCell>
                          <TableCell
                            align="center"
                            className={commonStyle.tableColumntext}
                          >
                            Price
                          </TableCell>
                          <TableCell
                            align="center"
                            className={commonStyle.tableColumntext}
                          >
                            Total Price
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {buyerOrderDetails.length > 0 ? (
                          buyerOrderDetails?.map((row: any, index: number) => {
                            return (
                              <TableRow
                                key={index}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">
                                  <Box
                                    className={`${commonStyle.wallUserInfo}`}
                                  >
                                    <Avatar
                                      sx={{ borderRadius: "100px" }}
                                      alt={"Story Person"}
                                      src={
                                        row?.gallery_images
                                          ? JSON.parse(row?.gallery_images)
                                          : minImage
                                      }
                                    />
                                    <Box className={commonStyle.ml10}>
                                      <Typography
                                        className={
                                          commonStyle.tableColumnBodytext
                                        }
                                      >
                                        {row?.name
                                          ? capitalize(`${row?.name}`)
                                          : ""}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </TableCell>

                                <TableCell align="center">
                                  <Typography
                                    className={commonStyle.tableColumnBodytext}
                                  >
                                    {row?.ordered_quantity
                                      ? `${row?.ordered_quantity}`
                                      : ""}
                                  </Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography
                                    className={commonStyle.tableColumnBodytext}
                                  >
                                    {row?.price_per_unit
                                      ? `$${row?.price_per_unit.toFixed(2)}`
                                      : "$0.00"}
                                  </Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography
                                    className={commonStyle.tableColumnBodytext}
                                  >
                                    {row?.price_per_unit &&
                                    row?.ordered_quantity
                                      ? `$${(
                                          row?.price_per_unit *
                                          row?.ordered_quantity
                                        ).toFixed(2)}`
                                      : "$0.00"}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            );
                          })
                        ) : (
                          <Typography
                            mt={2}
                            mb={2}
                            ml={2}
                            className={`${commonStyle.bold2}`}
                          >
                            {"Record Not Found"}
                          </Typography>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Box>
                  <Grid container>
                    <Grid item lg={7} md={7} sm={12}>
                      <Box
                        className={`${commonStyle.card} ${commonStyle.mt30} ${commonStyle.mr30} `}
                      >
                        <Box>
                          <div
                            style={{
                              paddingTop: "35px",
                              paddingLeft: "15px",
                              paddingRight: "15px",
                              paddingBottom: "80px",
                            }}
                          >
                            <p
                              className={`${commonStyle.font22} ${commonStyle.fontWeight500} ${commonStyle.textCenter} ${commonStyle.p0} ${commonStyle.m0}`}
                            >
                              Details
                            </p>
                            <div
                              style={{
                                paddingLeft: "20px",
                                paddingRight: "20px",
                                marginTop: "20px",
                              }}
                            >
                              <div
                                className={`${styles.summary_Detail_Container} ${commonStyle.mt15}`}
                              >
                                <p
                                  className={`${styles.address_title} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                  Name :
                                </p>
                                <p
                                  className={`${styles.address_value} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                  {buyerAddressDetail?.first_name &&
                                  buyerAddressDetail?.last_name
                                    ? capitalize(
                                        `${buyerAddressDetail?.first_name} ${buyerAddressDetail?.last_name}`
                                      )
                                    : ""}
                                </p>
                              </div>
                              <div
                                className={`${styles.summary_Detail_Container} ${commonStyle.mt15}`}
                              >
                                <p
                                  className={`${styles.address_title} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                  Email :
                                </p>
                                <p
                                  className={`${styles.address_value} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                  {buyerAddressDetail?.email
                                    ? buyerAddressDetail?.email
                                    : ""}
                                </p>
                              </div>
                              <div
                                className={`${styles.summary_Detail_Container} ${commonStyle.mt15}`}
                              >
                                <p
                                  className={`${styles.address_title} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                  Phone Number :
                                </p>
                                <p
                                  className={`${styles.address_value} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                  {buyerAddressDetail?.phone_number
                                    ? buyerAddressDetail?.phone_number
                                    : ""}
                                </p>
                              </div>
                               <div
                                style={{ alignItems: "flex-start" }}
                                className={`${styles.summary_Detail_Container} ${commonStyle.mt15}`}
                              >
                                <p
                                  className={`${styles.address_title} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                  City :
                                </p>
                                <p
                                  style={{ maxWidth: "70%", textAlign: "left" }}
                                  className={`${styles.address_value} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                {buyerAddressDetail?.city
                                    ? buyerAddressDetail?.city
                                    : ""}
                                </p>
                              </div>

                              <div
                                className={`${styles.summary_Detail_Container} ${commonStyle.mt15}`}
                              >
                                <p
                                  className={`${styles.address_title} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                  Post Code :
                                </p>
                                <p
                                  className={`${styles.address_value} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                  {buyerAddressDetail?.post_code
                                    ? buyerAddressDetail?.post_code
                                    : ""}
                                </p>
                              </div>
                              <div
                                style={{ alignItems: "flex-start" }}
                                className={`${styles.summary_Detail_Container} ${commonStyle.mt15}`}
                              >
                                <p
                                  className={`${styles.address_title} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                  Address :
                                </p>
                                <p
                                  style={{ maxWidth: "70%", textAlign: "left" }}
                                  className={`${styles.address_value} ${commonStyle.p0} ${commonStyle.m0}`}
                                >
                                  {buyerAddressDetail?.address
                                    ? buyerAddressDetail?.address
                                    : ""}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item lg={5} md={5} sm={12}>
                      <Box
                        className={`${commonStyle.card} ${commonStyle.mt30}`}
                      >
                        <Box>
                          <div
                            style={{
                              paddingTop: "35px",
                              paddingLeft: "15px",
                              paddingRight: "15px",
                              paddingBottom: "50px",
                            }}
                          >
                            <p
                              className={`${styles.summeryHeading} ${commonStyle.p0} ${commonStyle.m0}`}
                            >
                              Order summary
                            </p>
                            <div
                              style={{
                                paddingLeft: "20px",
                                paddingRight: "20px",
                              }}
                            >
                              <div className={styles.summary_Detail_Container}>
                                <p className={styles.title}>Subtotal</p>
                                <p className={styles.value}>
                                  {buyerAddressDetail?.sub_total
                                    ? `$${buyerAddressDetail?.sub_total.toFixed(
                                        2
                                      )}`
                                    : "$0.00"}
                                </p>
                              </div>
                              <div className={styles.summary_Detail_Container}>
                                <p className={styles.title}>Tax 7%</p>
                                <p className={styles.value}>
                                  {buyerAddressDetail?.tax
                                    ? `$${buyerAddressDetail?.tax.toFixed(2)}`
                                    : "$0.00"}
                                </p>
                              </div>
                              <div className={styles.summary_Detail_Container}>
                                <p className={styles.title}>Delivery</p>
                                <p className={styles.value}>
                                  {buyerAddressDetail?.sub_total &&
                                  buyerAddressDetail?.tax &&
                                  buyerAddressDetail?.total
                                    ? `$${(
                                        Number(buyerAddressDetail?.total) -
                                        Number((buyerAddressDetail?.sub_total +
                                          buyerAddressDetail?.tax))
                                      ).toFixed(2)}`
                                    : "$0.00"}
                                </p>
                              </div>
                            </div>
                            <div
                              className={styles.borderBottom}
                              style={{ marginLeft: "0px", marginRight: "0px" }}
                            ></div>
                            <div
                              style={{
                                paddingLeft: "20px",
                                paddingRight: "20px",
                              }}
                              className={`${styles.summary_Detail_Container} ${commonStyle.p0} ${commonStyle.m0}`}
                            >
                              <p className={styles.total}>Total</p>
                              <p className={styles.price}>
                                {buyerAddressDetail?.total
                                  ? `$${buyerAddressDetail?.total.toFixed(2)}`
                                  : "$0.00"}
                              </p>
                            </div>
              
                            <div className={styles.summary_Detail_Container}>
                                <p className={styles.title}>{`Expected payout to seller = $${(
                                        Number(buyerAddressDetail?.sub_total ?? 0) +
                                          Number(buyerAddressDetail?.delivery_price ?? 0) - Number(buyerAddressDetail?.conversion_fee ?? 0)
                                      ).toFixed(2)}`}</p>
                              </div>
                          </div>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Box>
          ) : loader ? (
            <Typography mt={2} mb={2} ml={2} className={`${commonStyle.bold2}`}>
              {"Loading ..."}
            </Typography>
          ) : (
            <Typography mt={2} mb={2} ml={2} className={`${commonStyle.bold2}`}>
              {"Record Not Found"}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrdersDetail;
